import { FC, ReactElement } from 'react'

import { InactiveUser } from '@/containers'
import { logout } from '@/redux/app/appLegacyActions'
import { useTypedDispatch } from '@/redux/store'

export const ConnectedInactiveUser: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()

    const handleLogoutButtonClick = (): void => {
        dispatch(logout())
    }

    return (
        <InactiveUser onLogoutButtonClick={handleLogoutButtonClick} />
    )
}
